module.exports = __webpack_public_path__ + "img/restaurant-15.0f8837ad.jpg";